/* Cart add-ons.
   1. Shipping protection: optional toggle that adds or removes the
      shipping-protection line, then re-renders the cart sections in place.
   2. Lifetime warranty: shown as text, never a cart line. Any old warranty
      line is removed, and protection goes when no case is left. A case is any
      line whose product type contains "Luggage". */
(function () {
  const PROT = 'shipping-protection';
  const WARRANTY = 'lifetime-warranty';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const parse = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
  const isCase = (item) => /luggage/i.test(item.product_type || '') && item.handle !== PROT && item.handle !== WARRANTY;
  const post = (path, body) =>
    fetch(`${root}${path}`, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) }).then((r) => {
      if (!r.ok) throw new Error(path);
      return r.json();
    });
  const getCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  async function refreshSections() {
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const notifBtn = document.getElementById('cart-notification-button');
    const sections = ['cart-icon-bubble'];
    if (items) sections.push(items.dataset.id);
    if (footer) sections.push(footer.dataset.id);
    if (notifBtn) sections.push('cart-notification-button');
    const res = await fetch(`${root}cart?sections=${sections.join(',')}`);
    const json = await res.json();
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && json['cart-icon-bubble']) bubble.innerHTML = parse(json['cart-icon-bubble'], '.shopify-section').innerHTML;
    if (items && json[items.dataset.id]) {
      const next = parse(json[items.dataset.id], '.js-contents');
      if (next) items.querySelector('.js-contents').innerHTML = next.innerHTML;
    }
    if (footer && json[footer.dataset.id]) {
      const next = parse(json[footer.dataset.id], '.js-contents');
      if (next) footer.querySelector('.js-contents').innerHTML = next.innerHTML;
    }
    if (notifBtn && json['cart-notification-button']) {
      notifBtn.innerHTML = parse(json['cart-notification-button'], '.shopify-section').innerHTML;
    }
  }

  async function removeProtection() {
    const cart = await getCart();
    const line = cart.items.find((i) => i.handle === PROT);
    if (!line) return cart;
    return post('cart/change.js', { id: line.key, quantity: 0 });
  }

  class TaloProtection extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input || this.bound) return;
      this.bound = true;
      this.input.addEventListener('change', () => this.toggle(this.input.checked));
    }
    async toggle(on) {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-busy');
      try {
        if (on) await post('cart/add.js', { items: [{ id: Number(this.dataset.variant), quantity: 1 }] });
        else await removeProtection();
        await refreshSections();
        document.querySelectorAll('talo-protection input').forEach((el) => (el.checked = on));
      } catch (e) {
        this.input.checked = !on;
      }
      this.busy = false;
      this.classList.remove('is-busy');
    }
  }
  if (!customElements.get('talo-protection')) customElements.define('talo-protection', TaloProtection);

  /* The lifetime warranty is included with every case and shown as text in the
     cart, not as a cart line: a $0 line made one case read "2 items" and fired a
     second add-to-cart event. Clear any warranty line left in older carts, and
     drop protection once no case is left. */
  let running = false;
  let queued = false;
  async function syncAddons() {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    try {
      do {
        queued = false;
        const cart = await getCart();
        const cases = cart.items.filter(isCase).length;
        const updates = {};
        cart.items.forEach((i) => {
          if (i.handle === WARRANTY || (cases === 0 && i.handle === PROT)) updates[i.key] = 0;
        });
        if (!Object.keys(updates).length) continue;
        await post('cart/update.js', { updates });
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
          return;
        }
        await refreshSections();
      } while (queued);
    } catch (e) {
      /* Network hiccup: the next cart change or page load runs the sync again. */
    }
    running = false;
  }

  let timer = null;
  const scheduleSync = () => {
    clearTimeout(timer);
    timer = setTimeout(syncAddons, 250);
  };

  function start() {
    /* constants.js declares PUB_SUB_EVENTS with const, so it is global but not on window. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
    const items = document.getElementById('main-cart-items');
    if (items && window.MutationObserver) new MutationObserver(scheduleSync).observe(items, { childList: true, subtree: true });
    window.addEventListener('pageshow', (e) => e.persisted && scheduleSync());
    syncAddons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
